import { AllVehiclesResponseModel, CommonResponse, VehicleResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { VehicleIdRequest } from './dto/vehicle-id-request';
import { VehicleMasterDTO } from './dto/vehicle.dto';
import { VehicleRequest } from './dto/vehicle.request';
import { VehicleMasterService } from './vehicle-master.service';
import {VehicleUpdateReq} from "../../../../../../libs/shared-models/masters/src/lib/vehicle_master/vehicleUpdate-req"
@ApiTags('VehicleMaster')
@Controller('vehicle-master')
export class VehicleMasterController {
    constructor(
        private vehiclemasterService: VehicleMasterService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
      /**
       * create or update Vehicle
       * @param vehicleMasterDTO 
       * @param isUpdate 
       * @param request 
       */
      @Post('/createVehicle')
      async createVehicle(@Body() vehicleMasterDTO:VehicleMasterDTO,isUpdate:boolean=false,@Req() request:Request): Promise<VehicleResponseModel> {
          try {
              // console.log(vehicleMasterDTO);
              return await this.vehiclemasterService.createVehicle(vehicleMasterDTO, false,request);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(VehicleResponseModel, error)
          }
      }
      @Post('/getVehicleByVehId')
      async getVehicleByVehId(@Body() vehicleIdRequest:VehicleIdRequest): Promise<VehicleResponseModel> {
          try {
              return await this.vehiclemasterService.getVehicleByVehId(vehicleIdRequest);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(VehicleResponseModel, error)
          }
      }
      /**
       * create or update vehicle
       * @param vehicleMasterDTO 
       * @param request 
       */
      @Post('/updateVehicle')
    async updateVehicle(@Body() vehicleMasterDTO: VehicleMasterDTO,@Req() request:Request): Promise<VehicleResponseModel> {
        try {
            return await this.vehiclemasterService.createVehicle(vehicleMasterDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(VehicleResponseModel, error)
        }
    }
    /**
     * get All Vehicles
     * @param request 
     */
    @Post('/getAllVehicles')
    async getAllVehicles(@Body() req?:UserRequestDto): Promise<AllVehiclesResponseModel> {
        try {
        return await this.vehiclemasterService.getAllVehicles(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllVehiclesResponseModel, error)
        }
    }
    /**
     * get All Vehicles
     * @param request 
     */
    @Post('/getAllActiveVehicles')
    async getAllActiveVehicles(@Req() request: Request): Promise<AllVehiclesResponseModel> {
        try {
        return await this.vehiclemasterService.getAllActiveVehicles();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllVehiclesResponseModel, error)
        }
    }
    /**
     * Active or DeActive Vehicle
     * @param VehicleReq 
     */
    @Post('/activateOrDeactivateVehicle')
    async activateOrDeactivateVehicle(@Body() VehicleReq: VehicleRequest): Promise<VehicleResponseModel> {
        try {
            return await this.vehiclemasterService.activateOrDeactivateVehicle(VehicleReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(VehicleResponseModel, err);
        }
    }
    @Post('/updateVehicleAvalibility')
    async updateVehicleAvalibility(@Body() req: VehicleUpdateReq): Promise<CommonResponse> {
      try {
        return await this.vehiclemasterService.updateVehicleAvalibility(req);
      } catch (error) {
        return this.applicationExceptionhandler.returnException(CommonResponse, error)
      }
    }
    @Post('/getAllAavailableVehicles')
    async getAllAavailableVehicles(): Promise<AllVehiclesResponseModel> {
      try {
        return await this.vehiclemasterService.getAllAavailableVehicles();
      } catch (error) {
        return this.applicationExceptionhandler.returnException(AllVehiclesResponseModel, error)
      }
    }
}
